import React from 'react';
import { Create, SimpleForm } from 'react-admin';
import { ACCOUNT_STATUS_TO_INT, LOGGING_STATUS_TO_INT } from '@/config/constants';
import { FormPageTitle, FormToolbar } from '@/components/shell';
import { generateApiKey } from '@/features/servers/generateApiKey';
import { AccountFields } from './AccountFields';

const BACK_TO = '/accounts';

interface AccountCreateValues {
  accountName: string;
  apiKey?: string;
  accountStatus: string;
  loggingStatus: string;
  allowDebugOutput?: boolean;
  rateLimitApplies?: boolean;
  rateLimitPerMin?: number;
  rateLimitPerDay?: number;
  primaryServerId: string;
  secondaryServerId?: string;
  licenseId: string | number;
  validityTimeFrame?: string;
  isLicenseBlocked?: boolean;
}

const transform = (data: AccountCreateValues) => ({
  AccountName: data.accountName,
  ApiKey: data.apiKey || '',
  AccountStatus: ACCOUNT_STATUS_TO_INT[data.accountStatus] ?? 1,
  LoggingStatus: LOGGING_STATUS_TO_INT[data.loggingStatus] ?? 1,
  AllowDebugOutput: data.allowDebugOutput || false,
  RateLimitApplies: data.rateLimitApplies || false,
  WhitelistApplies: false,
  RateLimitPerMin: data.rateLimitPerMin || 0,
  RateLimitPerDay: data.rateLimitPerDay || 0,
  PrimaryServerId: data.primaryServerId,
  SecondaryServerId: data.secondaryServerId || null,
  LicenseId: data.licenseId,
  ValidityTimeFrame: data.validityTimeFrame ? new Date(data.validityTimeFrame).toISOString() : null,
  IsLicenseBlocked: data.isLicenseBlocked || false,
});

export const AccountCreate = () => (
  <Create transform={transform} actions={<FormPageTitle mode="create" />}>
    <SimpleForm
      toolbar={<FormToolbar backTo={BACK_TO} />}
      defaultValues={{
        apiKey: generateApiKey(), accountStatus: 'Active',
        loggingStatus: 'None', rateLimitApplies: false, allowDebugOutput: false, isLicenseBlocked: false,
      }}
    >
      <AccountFields mode="create" />
    </SimpleForm>
  </Create>
);
